import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';
import '../../styles/admin.css'; // Reutilizar estilos admin
import '../../styles/tutor.css'; // Estilos específicos tutor

/**
 * Layout principal para páginas de tutor
 *
 * Proporciona la estructura base con contenido principal
 * Sin sidebar - navegación a través del header principal
 */
const TutorLayout = ({ children, title, subtitle }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const { isMobile } = useWindowSize();

  // Verificar autenticación
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar que el usuario sea tutor/padre
  if (user?.role !== 'parent') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="tutor-layout-container" style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isMobile ? '20px 20px 100px' : '40px 20px',
        boxSizing: 'border-box',
      }}>
        {title && (
          <div className="page-header" style={{
            marginBottom: '24px',
            padding: isMobile ? '16px 0' : '20px 0',
            borderBottom: '1px solid #e1e5e9',
          }}>
            <h1 style={{
              fontSize: isMobile ? '1.8rem' : '2.2rem',
              fontWeight: '700',
              color: '#061156',
              margin: '0 0 8px 0',
            }}>
              {title}
            </h1>
            {subtitle && (
              <p style={{
                fontSize: isMobile ? '15px' : '16px',
                color: '#6c757d',
                margin: 0,
                lineHeight: '1.5',
              }}>
                {subtitle}
              </p>
            )}
          </div>
        )}

        <div className="dashboard-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default TutorLayout;
